import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { aceGray, background, brandPrimary, charmGray, destructive, shuffleGray, titles } from '../../../styles/colors';
import { shadowSm } from '../../../styles/shadows';

export const s = StyleSheet.create({
	actingOnBehalfBar: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		paddingLeft: 24,
		paddingRight: 24,
	},
	actingOnBehalfLabel: {
		fontSize: 12,
		fontWeight: 'bold',
		color: charmGray,
	},
	surveyBuilderGate: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		height: '100%',
		padding: 24,
		boxSizing: 'border-box',
		color: charmGray,
		fontSize: 14,
	},
	briefStarters: {
		alignItems: 'flex-start',
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		paddingLeft: 48,
		paddingRight: 24,
	},
	surveyStarters: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 8,
		paddingLeft: 48,
		paddingRight: 24,
	},
	avatar: {
		width: 40,
		height: 40,
		flexShrink: 0,
	},
	contactCard: {
		width: `100%`,
		backgroundColor: 'white',
		boxShadow: shadowSm,
		border: `1px solid ${aceGray}`,
		padding: 16,
		maxWidth: 384,
		boxSizing: 'border-box',
		borderRadius: 8,
		cursor: 'pointer',
	},
	closeCustomContent: {
		width: 'fit-content',
		justifyContent: 'center',
	},
	errorMessageContainer: {
		borderRadius: 8,
		padding: 12,
		color: destructive,
		backgroundColor: `#fef2f2`,
		border: `1px solid ${destructive}`,
		width: `100%`,
		display: `flex`,
		flexDirection: `column`,
		gap: 8,
		boxSizing: 'border-box',
		alignItems: 'flex-start',
	},
	errorMessageDetails: {
		fontSize: 12,
		fontWeight: 'normal',
	},
	errorMessageButton: {
		backgroundColor: `white`,
		fontSize: 12,
	},
	flexCenter: {
		justifyContent: 'center',
		width: '100%',
	},
	inputContainer: {
		boxSizing: `border-box`,
		paddingLeft: 24,
		paddingRight: 24,
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	aiKitCta: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		margin: `0 24px`,
		':has(*) > span': {
			flex: 1,
		},
		':has(*) > svg': {
			display: 'block',
			width: 20,
			height: 20,
		},
	},
	closeBtn: {
		position: `absolute`,
		top: 16,
		right: 18,
		padding: 0,
		color: charmGray,
		':has(*) > svg': {
			display: `block`,
			width: 12,
			height: 12,
		},
		// Show only on mobile
		[THEME.queries.md]: {
			display: 'block',
			right: 32,
		},
	},
	assistantEmail: {
		display: `flex`,
		flexDirection: `column`,
		gap: 16,
		fontWeight: `normal`,
	},
	useEmailBtn: {
		width: `100%`,
	},
	assistantMessageContent: {
		minWidth: 0,
		display: `flex`,
		flexDirection: `column`,
		gap: 8,
		lineHeight: 1.929,
		':has(*) p': {
			margin: 0,
			padding: 0,
		},
		':has(*) h1': {
			margin: 0,
			padding: 0,
		},
		':has(*) h2': {
			margin: 0,
			padding: 0,
		},
		':has(*) h3': {
			margin: 0,
			padding: 0,
		},
		':has(*) h4': {
			margin: 0,
			padding: 0,
		},
		':has(*) h5': {
			margin: 0,
			padding: 0,
		},
		':has(*) h6': {
			margin: 0,
			padding: 0,
		},
	},
	userMessage: {
		color: charmGray,
		fontSize: `0.875rem`,
		lineHeight: `1.714rem`,
		boxSizing: `border-box`,
		paddingLeft: 24,
		paddingRight: 24,
	},
	assistantMessageSparkle: {
		flexShrink: 0,
	},
	assitantMessage: {
		display: `flex`,
		color: titles,
		gap: 4,
		fontSize: `0.875rem`,
		lineHeight: `1.25rem`,
		boxSizing: `border-box`,
		paddingLeft: 24,
		paddingRight: 24,
	},
	assitantMessageThinking: {
		alignItems: `center`,
	},
	root: {
		display: `flex`,
		height: `100%`,
	},
	sideContent: {
		flex: 1,
	},
	actionNav: {
		padding: `16px 8px`,
		display: `flex`,
		flexDirection: `column`,
		gap: 4,
		backgroundColor: background,
		borderLeft: `1px solid ${aceGray}`,
		height: `100%`,
	},
	tabActionButton: {
		padding: 8,
		display: `flex`,
		alignItems: `center`,
		justifyContent: `center`,
		borderRadius: 12,
		backgroundColor: 'white',
		border: `1px solid ${aceGray}`,
		[`:is([data-state="active"])`]: {
			backgroundColor: `#54a0d742`,
		},
	},
	chatWindow: {
		boxSizing: `border-box`,
		width: 390,
		height: `100%`,
		borderLeft: `1px solid ${aceGray}`,
		display: `flex`,
		flexDirection: `column`,
		paddingBottom: 8,
		position: `relative`,
		':has(*) p': {
			padding: 0,
			margin: 0,
		},
		[THEME.queries.md]: {
			width: '100%',
		},
	},
	universalChatWindow: {
		boxSizing: `border-box`,
		width: '100%',
		height: `100%`,
		display: `flex`,
		flexDirection: `column`,
		paddingBottom: 8,
		position: `relative`,
		':has(*) p': {
			padding: 0,
			margin: 0,
		},
	},
	chatContent: {
		flex: 1,
		display: `flex`,
		flexDirection: 'column',
		paddingTop: 16,
		paddingBottom: 16,
		overflowY: `auto`,
		gap: 16,
	},
	chatMessages: {
		display: `flex`,
		flexDirection: `column`,
		gap: 16,
		flex: 1,
		overflow: `auto`,
		padding: 16,
	},
	chatWindowHeader: {
		borderBottom: `1px solid ${aceGray}`,
		padding: `16px 24px`,
		display: `flex`,
		alignItems: `center`,
		gap: 8,
	},
	chatWindowHeaderStart: {
		display: `flex`,
		alignItems: `center`,
		gap: 8,
		color: brandPrimary,
		minWidth: 0,
		flex: 1,
	},
	chatWindowHeaderActions: {
		alignItems: 'center',
		display: 'flex',
		gap: 4,
	},
	chatWindowHeaderEnd: {
		display: 'flex',
		gap: 24,
	},
	leoAvatar: {
		width: 32,
		height: 32,
	},
	plusIconButton: {
		color: brandPrimary,
	},
	chatWindowHeaderTitle: {
		fontWeight: 'bold',
	},
	contactCardCompanyPill: {
		fontSize: '0.75rem',
		lineHeight: '1rem',
		padding: `4px 10px`,
		backgroundColor: shuffleGray,
		borderRadius: 16,
	},
	historyList: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 4,
		overflowY: 'auto',
		padding: `8px 12px`,
	},
	historyRow: {
		alignItems: 'flex-start',
		background: 'none',
		border: 'none',
		borderRadius: THEME.common.borderRadius,
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		padding: 16,
		boxSizing: 'border-box',
		textAlign: 'left',
		width: '100%',
		':hover': {
			backgroundColor: background,
		},
	},
	historyRowSelected: {
		backgroundColor: background,
	},
	historyRowTitle: {
		color: titles,
		// @ts-expect-error - aphrodite doesn't support webkit box
		display: '-webkit-box',
		fontSize: 14,
		lineHeight: '1.25rem',
		overflow: 'hidden',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: 2,
		wordWrap: 'break-word',
	},
	historyRowTitleUntitled: {
		color: charmGray,
		fontStyle: 'italic',
	},
	historyRowMeta: {
		alignItems: 'center',
		color: charmGray,
		display: 'flex',
		fontSize: 12,
		gap: 6,
	},
	historyStreamingDot: {
		backgroundColor: brandPrimary,
		borderRadius: '50%',
		flexShrink: 0,
		height: 6,
		width: 6,
	},
	historyEmpty: {
		alignItems: 'center',
		color: charmGray,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: 14,
		gap: 8,
		justifyContent: 'center',
		padding: 24,
		textAlign: 'center',
	},
	headerBackButton: {
		color: brandPrimary,
		flexShrink: 0,
	},
	headerTitleInputGroup: {
		border: 'none',
		boxShadow: 'none',
	},
	headerTitleEditAddon: {
		opacity: 0,
		':is([data-slot="input-group"]:hover *)': {
			opacity: 1,
		},
		':has(*) > svg': {
			width: 14,
			height: 14,
		},
	},
	headerTitleInput: {
		fontWeight: 500,
	},
	headerTitleForm: {
		display: 'flex',
		flex: 1,
		minWidth: 0,
	},
});
